.newNavbar {
  background: var(--pgm-sys-color-surface);
  position: sticky;
  top: 0;
  z-index: 99 !important;
}

.newNavbarContainer {
  align-items: center;
  display: flex;
  height: 56px;
  justify-content: space-between;
}

.logoContainer {
  align-items: center;
  display: flex;
  gap: 16px;
}

.logoContainer .logoLink {
  border-radius: 4px;
  display: flex;
  text-decoration: none;
}

.logoContainer .logoLink:hover,
.logoContainer .logoLink:focus {
  text-decoration: none;
}

.logoContainer .logoLink:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: 4px;
}

.logoContainer .logoCompact {
  display: none;
}

.navigationList {
  align-items: center;
  display: flex;
  gap: 16px;
  height: 100%;
  list-style: none;
  margin: 0;
  padding: 0 20px 0 0;
}

.newNavbarNavigation {
  align-items: center;
  display: flex;
  flex-grow: 0;
  justify-content: flex-end;
}

.newNavbarToggler {
  border: 0;
  display: none;
  margin-right: 8px;
  padding: 0;
}

.newNavbarTrailing {
  display: none;
}

.newNavbarMenuIcon {
  color: var(--pgm-sys-color-on-surface-variant);
  font-size: 24px;
  font-variation-settings:
    "FILL" 0,
    "wght" 400,
    "GRAD" 0,
    "opsz" 24;
  line-height: 1;
}

.navigationDropdown {
  position: relative;
}

.servicesMenu {
  --pgm-vertical-menu-width: 256px;
}

.institutionalMenu {
  --pgm-vertical-menu-width: 320px;
}

.newNavbarAttendantIcon {
  color: var(--pgm-sys-color-on-surface-variant);
  font-size: 24px;
  font-variation-settings:
    "FILL" 1,
    "wght" 400,
    "GRAD" 0,
    "opsz" 24;
  line-height: 1;
}

.drawerScrim,
.sheetScrim,
.drawer,
.sheet {
  display: none;
}

.decoratorLine {
  display: flex;
  gap: 2px;
  height: 4px;

  > div {
    flex: 1;
    height: 100%;
  }
}

.line3Container {
  display: flex;
  gap: 2px;

  > div {
    flex: 1;
    height: 100%;
  }
}

.line1 {
  background: var(--pgm-sys-color-brand-primary);
}

.line2 {
  background: var(--pgm-sys-color-brand-secondary);
}

.line3 {
  background: var(--pgm-sys-color-brand-tertiary);
}

@media (max-width: 1199.98px) {
  .newNavbarContainer {
    background: var(--pgm-sys-color-surface);
    gap: 8px;
    justify-content: flex-start;
  }

  .newNavbarToggler {
    display: inline-flex;
    margin-right: 0;
    order: -1;
  }

  .logoContainer {
    margin-right: auto;
  }

  .logoContainer .logoMosaic,
  .logoContainer .logoFull {
    display: none;
  }

  .logoContainer .logoCompact {
    display: flex;
  }

  .newNavbarNavigation {
    display: none;
  }

  .newNavbarTrailing {
    display: inline-flex;
    position: relative;
    z-index: 6;
  }

  .drawerScrim,
  .sheetScrim {
    background: var(--pgm-sys-color-scrim);
    display: block;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    right: 0;
    transition: opacity 0.2s ease;
  }

  .drawerScrim {
    bottom: 0;
    top: 60px;
    z-index: 2;
  }

  .sheetScrim {
    bottom: 0;
    top: 0;
    z-index: 4;
  }

  .scrimOpen {
    opacity: 0.32;
    pointer-events: auto;
  }

  .drawer {
    background: var(--pgm-sys-color-surface-container);
    border-radius: 0 16px 16px 0;
    box-shadow: var(--pgm-sys-elevation-level3);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100vh;
    height: 100dvh;
    left: 0;
    max-width: 320px;
    padding: 4px 8px 0;
    position: fixed;
    top: 0;
    transform: translateX(-100%);
    transition: transform 0.25s ease;
    width: 85%;
    z-index: 3;
  }

  .drawerOpen {
    transform: translateX(0);
  }

  .drawerClose {
    flex: 0 0 auto;
    margin: 4px;
  }

  .drawerScroll {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
    overflow-y: auto;
    padding: 4px;
  }

  .drawerNav {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .drawerItem {
    align-items: center;
    border-radius: 9999px;
    color: var(--pgm-sys-color-on-surface-variant);
    display: inline-flex;
    gap: 8px;
    max-width: 100%;
    overflow: hidden;
    padding: 10px 16px;
    position: relative;
    text-decoration: none;
  }

  .drawerItem::before {
    background: var(--pgm-sys-color-on-surface-variant);
    border-radius: inherit;
    content: "";
    inset: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transition: opacity 0.15s ease;
  }

  .drawerItem:hover::before {
    opacity: 0.08;
  }

  .drawerItem:active::before {
    opacity: 0.1;
  }

  .drawerItem:hover,
  .drawerItem:focus,
  .drawerItem:focus-visible {
    color: var(--pgm-sys-color-on-surface-variant);
    text-decoration: none;
  }

  .drawerItemActive,
  .drawerItemActive:hover,
  .drawerItemActive:focus {
    background: var(--pgm-sys-color-secondary-container);
    color: var(--pgm-sys-color-on-secondary-container);
    text-decoration: none;
  }

  .drawerItemActive::before {
    background: var(--pgm-sys-color-on-secondary-container);
  }

  .drawerDivider {
    background: var(--pgm-sys-color-outline-variant);
    border: 0;
    flex: 0 0 auto;
    height: 1px;
    margin: 8px 0;
    width: 100%;
  }

  .drawerItemIcon {
    color: inherit;
    flex-shrink: 0;
    font-size: 24px;
    font-variation-settings:
      "FILL" 0,
      "wght" 400,
      "GRAD" 0,
      "opsz" 24;
    line-height: 1;
  }

  .drawerItemLabel {
    color: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .drawerSection {
    color: var(--pgm-sys-color-on-surface-variant);
    margin: 16px 0 4px;
    padding: 0 16px;
  }

  .drawerFooter {
    flex: 0 0 auto;
    padding: var(--pgm-sys-spacing-4);
  }

  .sheet {
    background: var(--pgm-sys-color-surface-container-low);
    border-radius: 28px 28px 0 0;
    bottom: 0;
    box-shadow: var(--pgm-sys-elevation-level3);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: var(--pgm-sys-spacing-4);
    left: 0;
    max-height: 80dvh;
    overflow-y: auto;
    padding: 12px var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-8);
    position: fixed;
    right: 0;
    transform: translateY(100%);
    transition: transform 0.25s ease;
    z-index: 5;
  }

  .sheetOpen {
    transform: translateY(0);
  }

  .sheetHandle {
    align-self: center;
    background: var(--pgm-sys-color-on-surface-variant);
    border-radius: 9999px;
    height: 4px;
    opacity: 0.4;
    width: 32px;
  }

  .sheetTitle {
    color: var(--pgm-sys-color-on-surface);
    margin: var(--pgm-sys-spacing-2) 0 0;
  }

  .sheetLinks {
    display: flex;
    flex-direction: column;
    gap: var(--pgm-sys-spacing-5);
  }

  .sheetLink {
    align-items: center;
    display: inline-flex;
    gap: var(--pgm-sys-spacing-2);
    text-decoration: none !important;
    width: fit-content;
  }

  .sheetLinkText {
    text-decoration: underline;
  }

  .sheetLinkIcon {
    font-size: 20px;
    line-height: 1;
    text-decoration: none;
  }
}
